import { useEffect, useRef, useState } from "react";

export const usePortal = ({ element, id, style }: any) => {
  const elRef = useRef<Element | null>(null);
  const [container, setContainer] = useState<Element | null>(null);

  useEffect(() => {
    const el = document.createElement(element);
    el.id = id;
    el.style = style;
    document.getElementsByTagName("body")[0].prepend(el);
    elRef.current = el;
    setContainer(el);

    return () => {
      document.getElementsByTagName("body")[0].removeChild(el);
      elRef.current = null;
    };
  }, [element, id, style]);

  return container;
};
